/** @module Enums */ /** typedoc */
/**
 * Should match the PayoutStatusEnum from the Distribution MS
 *
 * https://github.com/Mixgenius/LANDR.Distribution/blob/master/src/LANDR.Distribution/Services/Payouts/PayoutStatusEnum.cs
 */
var ReleasePayoutStatusEnum;
(function (ReleasePayoutStatusEnum) {
    ReleasePayoutStatusEnum["Created"] = "Created";
    ReleasePayoutStatusEnum["Denied"] = "Denied";
    ReleasePayoutStatusEnum["Pending"] = "Pending";
    ReleasePayoutStatusEnum["Processing"] = "Processing";
    ReleasePayoutStatusEnum["Completed"] = "Completed";
    ReleasePayoutStatusEnum["Canceled"] = "Canceled";
    ReleasePayoutStatusEnum["Failed"] = "Failed";
    ReleasePayoutStatusEnum["UnClaimed"] = "UnClaimed";
    ReleasePayoutStatusEnum["Returned"] = "Returned";
    ReleasePayoutStatusEnum["OnHold"] = "OnHold";
    ReleasePayoutStatusEnum["Blocked"] = "Blocked";
    ReleasePayoutStatusEnum["PendingApproval"] = "PendingApproval";
    ReleasePayoutStatusEnum["Refunded"] = "Refunded";
})(ReleasePayoutStatusEnum || (ReleasePayoutStatusEnum = {}));

export { ReleasePayoutStatusEnum };
